export const formatPhoneWithOptionalIsd = (phoneNumber, isdCode) => {
  const phone = String(phoneNumber ?? "").trim();
  if (!phone) {
    return "";
  }

  const isd = String(isdCode ?? "").trim();
  return isd ? `${isd} ${phone}` : phone;
};
